import axios, { AxiosError } from 'axios';
import { auth } from '../firebase';
import { updateEmail, updatePassword } from "firebase/auth";
import {
  EmailAuthProvider,
  reauthenticateWithCredential,
} from "firebase/auth";


interface ApiError {
  message?: string;
}

export const backendAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

export const get_user = async () => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.get(
      'users/current',
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        }
      }    
    );
    return response;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Get industry types failed');
  }
};

export const update_user = async (data: {
  name?: string;
  email?: string;
  password?: string;
  currentPassword?: string;
}) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");

    // 🔐 Password update with reauth
    if (data.password && data.password.trim() !== "") {
      if (!data.currentPassword) {
        throw new Error("Current password required");
      }

      const credential = EmailAuthProvider.credential(
        user.email!,
        data.currentPassword
      );

      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, data.password);
    }

    // 🔐 Email update (also requires reauth sometimes)
    if (data.email && data.email !== user.email) {
      await updateEmail(user, data.email);
    }

    // 🗄 Backend update
    const backendData: any = {};
    if (data.name) backendData.name = data.name;
    if (data.email) backendData.email = data.email;

    if (Object.keys(backendData).length > 0) {
      const idToken = await user.getIdToken();

      await backendAPI.put("users/update", backendData, {
        headers: { Authorization: `Bearer ${idToken}` }
      });
    }

    return true;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const get_user_activity = async () => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.get(
      'users/activity',
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        }
      }    
    );
    return response;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Get industry types failed');
  }
};

export const get_user_todo = async () => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");
    const idToken = await user.getIdToken();

    const response = await backendAPI.get(
      'users/todo',
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        }
      }
    );
    return response;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Get industry types failed');
  }
};
